import { render } from "./ordersell.vue?vue&type=template&id=7e3ac975"
import script from "./ordersell.vue?vue&type=script&lang=js"
export * from "./ordersell.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__